import { Card } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ContractGrid from "../../app/contract/ContractGrid";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import AppConfig from "../../core/service/AppConfig";

/**
 * "Rapor Operasyonları → Sözleşmeler": hastane ihale sözleşmelerinde rapor sayısının ihaleye oranı.
 * Erişim CONTRACT_MANAGEMENT izniyle (rota AppRouter'da aynı izinle korunuyor).
 */
export default function ContractPage() {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${t('Contracts')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <LayoutWithSider fullWidth={true}>
            <Card title={t('Contracts')}>
                <ContractGrid />
            </Card>
        </LayoutWithSider>
    )
}
